module.exports = __webpack_public_path__ + "img/icono-muro.78ee0453.svg";